import React from "react";
import RoleNavigation from "../../shared/RoleNavigation";

export default function Navigation() {
  return <RoleNavigation role="department" />;
}
